<script>
import get from 'lodash/get'
import placeholderImg from '../../../../src/assets/logo-placeholder.svg'

export default {
  name: 'RetailerDetails',
  props: {
    retailer: {
      type: Object,
      required: true,
    },
    provider: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    enabled() {
      return this.retailer.active
    },
    retailerImg() {
      return this.retailer.logo || placeholderImg
    },
    category() {
      return get(this.retailer, 'category.name', '-')
    },
    providerName() {
      return get(this.provider, 'name')
    },
  },
}
</script>

<template>
  <div :class="$style.wrapper">
    <div :class="$style.innerWrapper">
      <div :class="$style.logo">
        <div :class="$style.imageWrapper">
          <img
            :src="retailerImg"
            :alt="retailer.name"
            :class="$style.image"
          >
        </div>
      </div>
      <div :class="$style.details">
        <status :status="retailer.active" />
        <data-list
          :class="[
            $style.datalist,
            !enabled && $style.inactive,
          ]"
        >
          <template v-if="providerName">
            <dt>Provider Name</dt>
            <dd>{{ providerName }}</dd>
          </template>
          <dt>Retailer Name</dt>
          <dd>{{ retailer.name }}</dd>
          <dt>Description</dt>
          <dd>{{ retailer.description }}</dd>
          <template v-if="retailer.website">
            <dt>Retailer Website</dt>
            <dd>{{ retailer.website }}</dd>
          </template>
          <dt>Categories</dt>
          <dd>
            {{ category }}
          </dd>
        </data-list>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
.innerWrapper {
  display: flex;
}

.imageWrapper {
  width: rem(212px);
  height: rem(212px);
  overflow: hidden;
  border-radius: rem(10px);
}

.image {
  width: 100%;
  height: auto;
}

.details {
  width: 100%;
  padding-left: 3rem;
}

.datalist {
  margin-top: rem(30px);
}

.inactive {
  opacity: 0.6;
}
</style>
